// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"projects-module--wrapper--3ZpRr","container":"projects-module--container--162u9"};